import React from "react";

import Box from "veneer/Box";
import styled from "veneer/styled";
import Typography from "veneer/Typography";

import { StructuralWidgetProps, getWidgetConfigString } from "./widgetConfig";
import WidgetContainer from "../WidgetContainer";

const NoteContent = styled(Box)({
  whiteSpace: "pre-wrap",
});

export default function TextNoteWidget({ config }: StructuralWidgetProps) {
  const title = getWidgetConfigString(config, "title", "Note");
  const text = getWidgetConfigString(config, "text", "Add some context here.");

  return (
    <WidgetContainer title={title}>
      <NoteContent px={1}>
        <Typography variant="body2">{text}</Typography>
      </NoteContent>
    </WidgetContainer>
  );
}
